import { useTranslate } from '@tolgee/react';
import { Space, Tabs } from 'antd';
import { QueryReturnListStateCountV2Resp, SecondaryProcessStatus } from 'services/api/refund';
import { getCount } from '../utils/count';
import { usePlatform } from '../hooks/usePlatformList';
import { SyncButton } from './SyncButton';
import { ExportButton } from './ExportButton';
import { StatusFilter } from '../hooks/useReturnList';
import { FilterState } from '../hooks/useFilter';

interface ReturnListTabsProps {
  query: FilterState;
  statusCount?: QueryReturnListStateCountV2Resp;
  statusFilter: StatusFilter;
  secondaryProcessStatus: SecondaryProcessStatus;
  onChange: (key: any) => void;
}

/**
 * Lazada 平台不在此处渲染, 在 LazadaReturnList.tsx
 */
export const ReturnListTabs = (props: ReturnListTabsProps) => {
  const { query, statusFilter, statusCount, secondaryProcessStatus, onChange } = props;
  const { t } = useTranslate();
  const platform = usePlatform()!;

  if (platform === 'SHOPEE') {
    return (
      <Tabs
        activeKey={statusFilter}
        onChange={onChange}
        tabBarExtraContent={
          <div className="flex px-4 gap-4">
            <ExportButton
              statusFilter={statusFilter}
              query={query}
              secondaryProcessStatus={secondaryProcessStatus}
              platform={platform}
            />
            <SyncButton />
          </div>
        }
      >
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.all')}(${getCount(
            statusCount?.total,
          )})`}
          key="ALL"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.newRequest')}(${getCount(
            statusCount?.requestCount,
          )})`}
          key="REQUEST"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.toRespond')}(${getCount(
            statusCount?.pendingCount,
          )})`}
          key="PENDING"
        />
        <Tabs.TabPane
          tab={
            <Space>
              {`${t('scene.orderWorkspace.returnRefundTab.tab.responded')}(${getCount(
                statusCount?.processedCount,
              )})`}
            </Space>
          }
          key="PROCESSED"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.completed')}(${getCount(
            statusCount?.completeCount,
          )})`}
          key="COMPLETE"
        />
      </Tabs>
    );
  }

  if (platform === 'MERCADO') {
    return (
      <Tabs
        activeKey={statusFilter}
        onChange={onChange}
        tabBarExtraContent={
          <div className="flex px-4 gap-4">
            <ExportButton
              statusFilter={statusFilter}
              query={query}
              secondaryProcessStatus={secondaryProcessStatus}
              platform={platform}
            />
            <SyncButton />
          </div>
        }
      >
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.all')}(${getCount(
            statusCount?.total,
          )})`}
          key="ALL"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.sellerPending')}(${getCount(
            statusCount?.pendingCount,
          )})`}
          key="PENDING"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.buyerPending')}(${getCount(
            statusCount?.buyerPendingCount,
          )})`}
          key="BUYER_PENDING"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.mediation')}(${getCount(
            statusCount?.mediationCount,
          )})`}
          key="MEDIATION"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.closed')}(${getCount(
            statusCount?.completeCount,
          )})`}
          key="COMPLETE"
        />
      </Tabs>
    );
  }

  if (platform === 'KWAI') {
    return (
      <Tabs activeKey={statusFilter} onChange={onChange}>
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.all')}(${getCount(
            statusCount?.total,
          )})`}
          key="ALL"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.pending')}(${getCount(
            statusCount?.pendingCount,
          )})`}
          key="PENDING"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.afterSalesCompleted')}(${getCount(
            statusCount?.completeCount,
          )})`}
          key="COMPLETE"
        />
        <Tabs.TabPane
          tab={`${t('scene.orderWorkspace.returnRefundTab.tab.afterSalesClosed')}(${getCount(
            statusCount?.closedCount,
          )})`}
          key="CLOSE"
        />
      </Tabs>
    );
  }

  return (
    <Tabs
      activeKey={statusFilter}
      onChange={onChange}
      tabBarExtraContent={
        <div className="flex px-4 gap-4">
          <ExportButton
            statusFilter={statusFilter}
            query={query}
            secondaryProcessStatus={secondaryProcessStatus}
            platform={platform}
          />
        </div>
      }
    >
      <Tabs.TabPane
        tab={`${t('scene.orderWorkspace.cancelOrderTab.tab.all')}(${getCount(statusCount?.total)})`}
        key="ALL"
      />
      <Tabs.TabPane
        tab={`${t('scene.orderWorkspace.cancelOrderTab.tab.pending')}(${getCount(
          statusCount?.pendingCount,
        )})`}
        key="PENDING"
      />
      <Tabs.TabPane
        tab={`${t('scene.orderWorkspace.cancelOrderTab.tab.processing')}(${getCount(
          statusCount?.processCount,
        )})`}
        key="PROCESS"
      />
      <Tabs.TabPane
        tab={`${t('scene.orderWorkspace.cancelOrderTab.tab.completed')}(${getCount(
          statusCount?.completeCount,
        )})`}
        key="COMPLETE"
      />
    </Tabs>
  );
};
